import React, { useContext } from "react";

import { MySelectionContext } from "./MySelectionContext";
import { ButtonBack } from "components/Atoms/Button";

const MySelectionBackButton = () => {
  const mySelection = useContext(MySelectionContext);

  if (!mySelection.enabled) {
    return null;
  }

  return <div><ButtonBack
    label={RESX.SelectionManager.BackToFilters}
    onClick={() => { mySelection.toggleShowOnlyMySelection(); }}
  /></div>;
};

export default MySelectionBackButton;